var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alertCount",class:_vm.type},[_c('bkf-alert'),_vm._v(" "),_c('bkfAlertBadge',[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }